import styled, { keyframes, css } from "styled-components";

const blink = keyframes`
  0% {
    box-shadow: 0 0 25px 0 rgba(0,0,0, 0.5) inset;
  }
  50% {
    box-shadow: 0 0 35px 0 rgba(0,0,0, 0.6) inset;
  }
  100% {
    box-shadow: 0 0 25px 0 rgba(0,0,0, 0.5) inset;
  }
`;

const animation = ({ active }) => {
  if (active) {
    return css`
      animation: ${blink} 2s infinite;
    `;
  }
  return "";
};

export default styled.div`
  box-sizing: border-box;
  height: 70px;
  width: 70px;
  border-radius: 3px;
  border: 3px solid #00ffdb;
  background: ${props => (props.active ? "#00ffdb" : "")};
  cursor: pointer;
  ${props => animation(props)}
`;
